import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/WPS_WLAN_Schnellverbindung_mit_einer_AVM_FritzBox.mp4" />
        </Player>
        <EuiText>
            <p>WPS / WLAN Schnellverbindung mit einer AVM Fritz!Box. Auf <OutboundLink href="https://www.youtube.com/watch?v=UEVZMmb5q3I" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard